export enum CHECKBOX_STATE {
  NONE = 'none',
  CHECKED = 'checked',
}
